import {inject, Injectable} from '@angular/core';
import {Order} from '@features/sales/domain/entities/order/order.entity';
import {OrderDTO, OrderStatus} from '@features/sales/domain/models/order/order.model';
import {OrderDraft} from '@features/sales/domain/models/order/order-split.model';
import {SalesSessionContext} from '@features/sales/domain/ports/sales-session.port';
import {OrderIdProvider} from '../services/order-id.provider';

@Injectable({providedIn: 'root'})
export class OrderFactory {
  private readonly idProvider = inject(OrderIdProvider);

  fromDraft(draft: OrderDraft, ctx: SalesSessionContext): Order {
    return new Order(this.buildDto(draft, ctx));
  }

  private buildDto(draft: OrderDraft, context: SalesSessionContext): OrderDTO {
    const {items, type} = draft;
    const {accountId, waiterId, locationId, cashDrawerId, serviceId} = context;
    const totalAmount = items.reduce((sum, item) => sum + item.amount, 0);

    return {
      id: this.idProvider.generate(),
      status: OrderStatus.OPEN,
      accountId,
      waiterId,
      locationId,
      cashDrawerId,
      serviceId,
      entries: items,
      totalAmount,
      type,
    };
  }
}
